import { publicApi } from '../../../shared/api/apiClientUtils';

export interface InvitationInfoResponse {
  invitationId: string;
  organisationName: string;
  requiresProfileCapture: boolean;
  requiresDataSharingConsent: boolean;
  isBookingWork: boolean;
  givenName?: string;
  familyName?: string;
}

export interface AcceptInvitationRequest {
  invitationId: string;
}

export interface AcceptInvitationResponse {
  identityToken: string;
  refreshToken: string;
  organisationId: string;
}

export interface MagicLinkTokenResponse {
  token: string;
  refreshToken?: string;
}

export interface MagicLinkCodeResponse {
  email: string;
  code: string;
}

export interface CaptureProfileRequest {
  givenName: string;
  familyName: string;
  primaryPhoneNumber: string;
}

export interface ConfirmConsentRequest {
  consent: boolean;
}

/**
 * Get invitation information by ID
 */
export const getInvitationInfo = async (
  invitationId: string
): Promise<InvitationInfoResponse> => {
  const response = await publicApi.get<InvitationInfoResponse>(
    `/api/v1/invitation/${invitationId}`
  );
  return response.data;
};

/**
 * Accept an invitation and get authentication tokens
 */
export const acceptInvitation = async (
  request: AcceptInvitationRequest
): Promise<AcceptInvitationResponse> => {
  const response = await publicApi.post<AcceptInvitationResponse>(
    '/api/v1/invitation/accept',
    request
  );
  return response.data;
};

/**
 * Capture profile information for a new user
 */
export const captureProfile = async (
  invitationId: string,
  request: CaptureProfileRequest
): Promise<void> => {
  await publicApi.post(
    `/api/v1/invitation/${invitationId}/capture-profile`,
    request
  );
};

/**
 * Confirm consent for data sharing
 */
export const confirmConsent = async (
  invitationId: string,
  request: ConfirmConsentRequest
): Promise<void> => {
  await publicApi.post(
    `/api/v1/invitation/${invitationId}/confirm-consent`,
    request
  );
};
